'use client'

import { useEffect, useRef } from 'react'
import { useSession } from 'next-auth/react'
import { getApiV1ReferralsInfo } from '@/lib/api-client/metka-client'
import { apiClient } from '@/lib/api-client'

// Глобальный флаг для предотвращения дублирования при множественном рендере компонента
let globalClaimInProgress = false
let globalLastAttemptTs = 0
const THROTTLE_MS = 5000 // Не чаще раза в 5 секунд

export function ReferralClaimEffect() {
    const { data: session, status } = useSession()
    const attemptedRef = useRef(false)

    useEffect(() => {
        if (status !== 'authenticated') return
        if (attemptedRef.current) return // Уже пытались в этом экземпляре компонента

        const now = Date.now()
        if (globalClaimInProgress || (now - globalLastAttemptTs < THROTTLE_MS)) {
            return
        }

        attemptedRef.current = true
        globalClaimInProgress = true
        globalLastAttemptTs = now

        const run = async () => {
            try {
                const userId = (session as any)?.user?.id || (session as any)?.user?.sub || (session as any)?.user?.email || 'unknown'
                const storageKey = `ref-claim-done-${userId}`
                const already = localStorage.getItem(storageKey) === '1'
                if (already) {
                    return
                }

                // HttpOnly cookie ref_t недоступна из JS, проверяем наличие реферала через BFF
                let info: any
                try {
                    const infoResp = await getApiV1ReferralsInfo()
                    info = (infoResp as any).data
                } catch (e) {
                    console.warn('[ReferralClaimEffect] Info request failed:', e)
                    return
                }
                if (!info?.hasReferral) {
                    return
                }

                // Use dedicated Next.js API route that handles cookie deletion
                const claimData = await apiClient.claimReferral()
                const ok = claimData?.ok === true
                if (ok) {
                    // Mark as done
                    localStorage.setItem(storageKey, '1')
                }
            } catch (e) {
                console.error('[ReferralClaimEffect] Claim failed:', e)
            } finally {
                globalClaimInProgress = false
            }
        }

        void run()
    }, [status, session])

    return null
}


